import React, { Fragment, useEffect} from 'react';
import "./Objects.css";
import { getObjects } from '../../../api/User';
import { userActions } from '../../../context/reducers/user';
import { failed } from '../../../utils/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import { decryptData } from '../../../utils/helper';

function ObjectListing() {
  let token = useSelector(state => state.userReducer.token);
  let objects = useSelector(state => state.userReducer.objectListing);
  const dispatch = useDispatch();
  const getObjectsListing = async()=>{
    let res;
    try {
        res = await getObjects({dispatch, token});
        const responseData = decryptData(res?.data);
        if (res?.status === "SUCCESS") {
            dispatch(userActions.objectListing(responseData));
        }
    } catch (error) {
        failed(res?.message);
    }
  };

  useEffect(() => {
    getObjectsListing();
  }, []);

  return (
    <>
      <div className="">
        <div className="forms_block_workflow profile_main_two">
          <div className="table-wrapper mt-2">
            <table className='scroll-table-five'>
              <thead>
                <tr className="header_table">
                  <th>Object Name</th>
                  <th>Object Permissions</th>
                  <th>Total Fields</th>
                </tr>
              </thead>
              <tbody className='scrollable-tbody-five'>
              {objects?.length && objects?.map((object,index)=>(
              <Fragment key={object?._id}>
                <tr>
                  <td colSpan={8} className="bg_light"></td>
                </tr>
                <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                  <td>{object?.objectName}</td>
                  <td>{object.objectPermissions.toString()}</td>
                  <td>{object?.totalFields}</td>
                </tr>
                </Fragment>
              ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default ObjectListing;
